import { array, func } from 'prop-types'
import React from 'react'
import { Card, styled, Typography } from '@mui/material'

const TbColumn = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',

  minHeight: '52px',
  maxHeight: '52px',
  alignItems: 'center',
  padding: '0 0.3rem'
}))

const TbTitle = styled('div')(() => ({
  fontWeight: 'bold',
  textTransform: 'capitalize',
  lineHeight: '0.95rem',
  fontSize: '0.95rem'
}))

const TbRow = styled('div')(() => ({
  // border: '1px solid lightgray',
  boxShadow: '0px 0px 1.2px black',
  borderRadius: '2px',
  margin: '0',
  padding: '0.3rem'
}))

const StyledCard = styled(Card)(({ theme }) => ({
  height: '91%',
  overflowY: 'scroll',
  [theme.breakpoints.up('md')]: {
    display: 'none'
  }
}))

const StyledP = styled(Typography)`
  font-size: 0.9rem;
  line-height: 0.9rem;
  text-align: center;
  color: black;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  margin-left: 0.5rem;
`
const StyledPagination = styled('div')(() => ({
  display: 'none!important',
  background: 'blue'
}))
const MobileTable = ({ rows = [], columns = [], Pagination }) => {
  return (
    <>
      <StyledCard elevation={0}>
        {rows.map((row, i) => {
          let test
          return (
            <TbRow key={i}>
              {columns.map((column, i) => {
                test = Object.hasOwnProperty.call(column, 'renderCell')
                let RC = () => <div>nada</div>
                if (test) {
                  const Linha = column.renderCell
                  const Test = () => <Linha row={row} />
                  RC = Test
                }
                return (
                  <div key={i}>
                    {!test && (
                      <TbColumn>
                        <TbTitle> {column.headerName} </TbTitle>
                        <StyledP> {row[column.field]}</StyledP>
                      </TbColumn>
                    )}
                    {test && (
                      <TbColumn>
                        <TbTitle> {column.headerName} </TbTitle>
                        <div style={{ display: 'flex' }}>
                          <RC />
                        </div>
                      </TbColumn>
                    )}
                  </div>
                )
              })}
            </TbRow>
          )
        })}

        {rows.length === 0 && <div>Nenhuma linha</div>}
      </StyledCard>
      <StyledPagination>
        <Pagination />
      </StyledPagination>
    </>
  )
}

MobileTable.propTypes = {
  rows: array,
  columns: array,
  Pagination: func
}

export default MobileTable
